/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module DriverupdaterecommendationTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface DriverUpdateRecommendationRequest {
    [k: string]: any;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverUpdateRecommendation".
 */
export interface DriverUpdateRecommendation {
    /**
     * Human-readable update name
     */
    name: string;
    /**
     * Update version in XXX.YY format
     */
    version: string;
    /**
     * Release date/time in ISO 8601 format
     */
    releaseDateTime: string;
    /**
     * URL to download installer from
     */
    downloadURL: string;
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetDriverUpdateRecommendationReturn".
 */
export interface GetDriverUpdateRecommendationReturn {
    result?: DriverUpdateRecommendation;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetUserDriverTypePreferenceReturn".
 */
export interface GetUserDriverTypePreferenceReturn {
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetUserDriverTypePreferenceParameters".
 */
export interface SetUserDriverTypePreferenceParameters {
    driverType: DriverTypeEnum;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetAutomaticDriverDownloadEnabledReturn".
 */
export interface GetAutomaticDriverDownloadEnabledReturn {
    /**
     * true if automatic driver update download is enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetAutomaticDriverDownloadEnabledParameters".
 */
export interface SetAutomaticDriverDownloadEnabledParameters {
    /**
     * Enable or disable automatic driver update download
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "RegisterDriverUpdateCheckProgressNotificationsReturn".
 */
export interface RegisterDriverUpdateCheckProgressNotificationsReturn {
    status: DriverUpdateCheckProgress;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetGRDEditorPreviewModeReturn".
 */
export interface GetGRDEditorPreviewModeReturn {
    /**
     * true if GRD editor preview mode is enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "GetDriverUpdateNotificationEnabledReturn".
 */
export interface GetDriverUpdateNotificationEnabledReturn {
    /**
     * true if driver update desktop notifications are enabled
     */
    isEnabled: boolean;
}
/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "SetDriverUpdateNotificationEnabledParameters".
 */
export interface SetDriverUpdateNotificationEnabledParameters {
    /**
     * Enable or disable driver update desktop notifications
     */
    isEnabled: boolean;
}

/**
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverTypeEnum".
 */
export enum DriverTypeEnum {
    GameReadyDriver = 0,
    CreatorReadyDriver = 1
}
/**
 * Defines current state of driver update check
 *
 * This interface was referenced by `DriverUpdateRecommendationRequest`'s JSON-Schema
 * via the `definition` "DriverUpdateCheckProgress".
 */
export enum DriverUpdateCheckProgress {
    started = 'started',
    finished = 'finished',
    failed = 'failed',
    cancelled = 'cancelled'
}


}
